import { defineStore } from 'pinia'
import api from '@/services/api'

export const useTestimonialStore = defineStore('testimonialStore', {
  state: () => ({
    testimonials: [],
    testimonialCount: 0,
    isLoading: false
  }),
  actions: {
    async fetchTestimonials(param = {}) {
      this.isLoading = true

      try {
        const response = await api.post('api/testimonial/fetch', param)
        const data = response.data?.data || []

        this.testimonials = Array.isArray(data) ? data : []
        this.testimonialCount = response.data?.total || this.testimonials.length
      } catch (error) {
        console.error('Error fetching testimonials:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
})
